module.exports = __webpack_public_path__ + "static/media/star-christmas.f32c5888.svg";